/**
 * VIP Offers Resource Client
 * Axios-based API client for VIP offer endpoints
 */
export class VipOffersResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Get VIP preview showing potential savings
     */
    async getVipPreview(sessionId, vipOfferIds) {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/vip-preview`, {
            orderBumpOfferIds: vipOfferIds,
            orderBumpType: 'vip',
        });
    }
    /**
     * Toggle an order bump (used for VIP offers)
     */
    async toggleOrderBump(sessionId, orderBumpOfferId, selected) {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/toggle-order-bump`, {
            orderBumpOfferId,
            selected,
        });
    }
}
